// extracted by mini-css-extract-plugin
module.exports =  {"clear":"bfSjMnMw6ORu27vhEgas"};